import TextStyle from '@rezdy/components/TextStyle';
import Link from '@rezdy/components/Link';
import React from 'react';
import { resendVerificationCode } from '../../services/auth';
import { withTranslation, WithTranslation } from 'react-i18next';

export class ResendCode extends React.PureComponent<{ username: string } & WithTranslation> {
    private second = 1000;
    private resendCodeInterval = 0;

    state = {
        seconds: 0,
        minutes: 0,
    };

    startTimer = () => {
        this.resendCodeInterval = setInterval(() => {
            if (this.state.seconds > 0) {
                this.setState({
                    seconds: this.state.seconds - 1,
                });
            }
            if (this.state.seconds === 0) {
                if (this.state.minutes === 0) {
                    clearInterval(this.resendCodeInterval);
                } else {
                    this.setState({
                        minutes: this.state.minutes - 1,
                        seconds: 59,
                    });
                }
            }
        }, this.second);
    };

    resendCode = () => {
        this.setState(
            {
                seconds: 59,
                minutes: 4,
            },
            () => {
                this.startTimer();
                resendVerificationCode({
                    username: this.props.username,
                });
            }
        );
    };

    componentWillUnmount() {
        clearInterval(this.resendCodeInterval);
    }

    render() {
        const { seconds, minutes } = this.state;
        const { i18n } = this.props;
        if (this.state.seconds || this.state.minutes) {
            return (
                <TextStyle as="p">
                    {i18n.t('resendCode.sent')}
                    <br />
                    {i18n.t('resendCode.wait', {
                        timer: `${minutes > 0 ? `${minutes}:${seconds}` : seconds}`,
                    })}
                </TextStyle>
            );
        }
        return (
            <TextStyle as="p">
                <Link onClick={this.resendCode}>Resend verification code</Link>
            </TextStyle>
        );
    }
}

export default withTranslation()(ResendCode);
